export const EVENT_NAME_FOR_USER_FLOW = {
  MemberSignUpFormShow: 'MemberSignUpFormShow',
  MemberSignUpFormSubmit: 'MemberSignUpFormSubmit',
  ThirdPartySignUpClick: 'ThirdPartySignUpClick',
  ThirdPartyLoginClick: 'ThirdPartyLoginClick',
  MemberLoginClick: 'MemberLoginClick',
  MemberLoginFormSubmit: 'MemberLoginFormSubmit',
  SMSVerificationCodeSend: 'SMSVerificationCodeSend',
  SMSVerificationFormShow: 'SMSVerificationFormShow',
  SMSVerificationSendButtonClick: 'SMSVerificationSendButtonClick',
  SMSVerificationSubmit: 'SMSVerificationSubmit',
  RecaptchaVerificationStart: 'RecaptchaVerificationStart',
  RecaptchaVerificationComplete: 'RecaptchaVerificationComplete',
  MemberSignUpInfoFormShow: 'MemberSignUpInfoFormShow',
  MemberSignUpInfoSubmit: 'MemberSignUpInfoSubmit',
  MemberSignUpSucceed: 'MemberSignUpSucceed',
  MemberLoginFormShow: 'MemberLoginFormShow',
  MemberLoginSucceed: 'MemberLoginSucceed',
  UpdateMemberInfoFormShow: 'UpdateMemberInfoFormShow',
  UpdateMemberInfoSucceed: 'UpdateMemberInfoSucceed',
  CartMemberLoginClick: 'CartMemberLoginClick',
  CartThirdPartySignUpClick: 'CartThirdPartySignUpClick',
  AnnouncementBarClick: 'AnnouncementBarClick',
  AnnouncementBarSwipe: 'AnnouncementBarSwipe',
  PDPTabClick: 'PDPTabClick',
  ImageLightboxClick: 'ImageLightboxClick',
  BreadCrumbClick: 'BreadCrumbClick',
  ProductImageView: 'ProductImageView',
  ProductMainInfoClick: 'ProductMainInfoClick',
  ProductReviewView: 'ProductReviewView',
  PromotionInfoView: 'PromotionInfoView',
  PromotionLinkClick: 'PromotionLinkClick',
  PromotionExpand: 'PromotionExpand',
  ProductDescriptionView: 'ProductDescriptionView',
  AdditionalProductPhotoView: 'AdditionalProductPhotoView',
  MiniCartImpression: 'MiniCartImpression',
};

export const EXPERIMENT_NAME = {
  // consts for checkout revamp AB testing
  checkoutRevampCart: 'checkout_revamp_cart_page',
  pdpRevamp: 'pdp_revamp',
};

export const TRACKER_EXPERIMENT_VARIATION_TYPE = {
  control: 'control',
  variant: 'variant',
};

export const EVENT_NAME_FOR_CHECKOUT = {
  CheckoutNameInput: 'CheckoutNameInput',
};

export const EVENT_CATEGORY_FOR_USER_FLOW = {
  Storefront: 'Storefront',
  SignUp: 'SignUp',
  MemberLogin: 'MemberLogin',
  UserVerification: 'UserVerification',
  ProfileUpdate: 'ProfileUpdate',
  PDP: 'PDP',
};

export const VALUE_FOR_USER_FLOW = {
  email: 'email',
  mobile: 'mobile',
  email_and_mobile: 'email_and_mobile',
  facebook: 'facebook',
  google: 'google',
  line: 'line',
  initial_signup: 'initial_signup',
  signup_resend: 'signup_resend',
  member_info_update: 'member_info_update',
  merchant: 'merchant',
  shopline: 'shopline',
  email_only: 'email_only',
  mobile_only: 'mobile_only',
  sms: 'sms',
  none: 'none',
};

export const PROPERTY_FOR_USER_FLOW = {
  sign_up_option: 'sign_up_option',
  third_party_sign_up_option: 'third_party_sign_up_option',
  third_party_login_option: 'third_party_login_option',
  sms_verification: 'sms_verification',
  accept_marketing: 'accept_marketing',
  purpose: 'purpose',
  verification_type: 'verification_type',
  set_up_by: 'set_up_by',
  login_option: 'login_option',
  update_info: 'update_info',
  need_verification: 'need_verification',
  pass_time: 'pass_time',
};

/** @constant */
export const EVENT_NAME_FOR_PAGE_VIEW = {
  // We planned to rename 'View' to 'PageView' to match the Category + Name pattern
  // However, too many downstream applications still use 'View' for data calculations
  // TODO: Rename to 'PageView' after downstream applications complete data migration
  PageView: 'View',
};

/**
 * Lv2 View: which interface the View came from. Page identity lives in
 * page_type, not here — see SL-52838.
 * @constant
 */
export const VIEW_FROM = {
  PAGE: 'page',
  QUICK_CART_POPUP: 'quick_cart_popup',
  // One page store exception: opened by tapping the product image
  PRODUCT_DETAIL_POPUP: 'product_detail_popup',
  // Cart promotion gift and member point redeem gift variation popups
  GIFT_VARIATION_POPUP: 'gift_variation_popup',
};

/** @constant */
export const VIEW_ACTION = {
  LOAD: 'load',
  VARIATION_SWITCH: 'variation_switch',
};

/** @constant */
export const EVENT_NAME_FOR_PRODUCT_LIST = {
  RecommendItem: 'RecommendItem',
  ProductClick: 'ProductClick',
  ViewRelatedProducts: 'ViewRelatedProducts',
  WishlistAdd: 'WishlistAdd',
  WishlistRemove: 'WishlistRemove',
  ProductImpression: 'ProductImpression',
};

export const EVENT_NAME_FOR_ARCHIVE_ORDERS = {
  ORDER_NUMBER_LINK_CLICK: 'OrderNumberLinkClick',
};

export const EVENT_POSITION_FOR_ARCHIVE_ORDERS = {
  MEMBER_CENTER_CREDIT_HISTORY: 'membercenter_credit_history',
  MEMBER_CENTER_POINT_HISTORY: 'membercenter_point_history',
};

export const EVENT_CREATED_AT_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const EVENT_NAME_FOR_SUBSCRIPTION = {
  MEMBER_SUBSCRIPTION_BUTTON_CLICK: 'MemberSubscriptionButtonClick',
  MEMBER_SUBSCRIPTION_POPUP_CLICK: 'MemberSubscriptionPopupClick',
};

export const EVENT_CATEGORY_FOR_SUBSCRIPTION = {
  MEMBER_SUBSCRIPTION: 'MemberSubscription',
};

export const EVENT_PROPERTY_FOR_SUBSCRIPTION = {
  SUBSCRIPTION_TYPE: 'subscription_type',
  SUBSCRIPTION_PATH: 'subscription_path',
  THIRD_PARTY: 'third_party',
};

export const EVENT_PROPERTY_VALUE_FOR_SUBSCRIPTION = {
  // SUBSCRIPTION_TYPE
  PROMOTION_NOTIFICATION: 'promotion_notification',
  ORDER_NOTIFICATION: 'order_notification',
  // SUBSCRIPTION_PATH
  SIGN_UP_PAGE: 'sign_up_page',
  MEMBER_CENTER: 'member_center',
  ORDER_CONFIRM_PAGE: 'order_confirm_page',
  ORDER_PAYMENT_SLIPS_UPLOAD_PAGE: 'order_payment_slips_upload_page',
  // THIRD_PARTY
  FACEBOOK: 'facebook',
  LINE: 'line',
};

const EVENT_NAME_FOR_TAG_PRODUCTS_PAGE = {
  FIXED_RECOMMENDATION_BAR_CLICK: 'AttributeTagEntranceClick',
};

export const USER_ACTION_TYPES = {
  CHECKOUT: 'Checkout',
  ADD_ITEM: 'AddItem',
  UPDATE_ITEM: 'UpdateItem',
  REMOVE_ITEM: 'RemoveItem',
  ADD_VARIATION_GIFT: 'AddVariationGift',
  REMOVE_VARIATION_GIFT: 'RemoveVariationGift',
};

export const TRACKER_GENERAL_EVENT_TYPES = {
  REGISTRATION: 'TRACK.REGISTRATION',
  SEARCH: 'TRACK.SEARCH',
  VIEW_CONTENT: 'TRACK.VIEW_CONTENT',
  ADD_TO_CART: 'TRACK.ADD_TO_CART',
  REMOVE_FROM_CART: 'TRACK.REMOVE_FROM_CART',
  START_CHECKOUT: 'TRACK.START_CHECKOUT',
  INITIATE_CHECKOUT: 'TRACK.INITIATE_CHECKOUT',
  ADD_SHIPPING: 'TRACK.ADD_SHIPPING',
  ADD_BILLING: 'TRACK.ADD_BILLING',
  PURCHASE: 'TRACK.PURCHASE',
  LOAD_CART_PAGE: 'TRACK.LOAD_CART_PAGE',
  LOAD_CHECKOUT_PAGE: 'TRACK.LOAD_CHECKOUT_PAGE',
  PRODUCT_CLICK: 'TRACK.PRODUCT_CLICK',
  ADD_TO_WISHLIST: 'TRACK.ADD_TO_WISHLIST',
  REMOVE_FROM_WISHLIST: 'TRACK.REMOVE_FROM_WISHLIST',
  ...EVENT_NAME_FOR_USER_FLOW,
  ...EVENT_NAME_FOR_ARCHIVE_ORDERS,
  ...EVENT_NAME_FOR_SUBSCRIPTION,
  ...EVENT_NAME_FOR_TAG_PRODUCTS_PAGE,
};

// @TODO: integration with original events
export const ONE_PAGE_STORE_TRACKER_TYPE = {
  AddItem: USER_ACTION_TYPES.ADD_ITEM,
  CartImpression: 'CartImpression',
  Checkout: USER_ACTION_TYPES.CHECKOUT,
  CheckoutInput: 'CheckoutInput',
  MiniCartButtonClick: 'MiniCartButtonClick',
  OrderCheckoutButtonClick: 'OrderCheckoutButtonClick',
  ProductClick: EVENT_NAME_FOR_PRODUCT_LIST.ProductClick,
  ProductImpression: EVENT_NAME_FOR_PRODUCT_LIST.ProductImpression,
  RemoveItem: USER_ACTION_TYPES.REMOVE_ITEM,
  UpdateItem: USER_ACTION_TYPES.UPDATE_ITEM,
  AddVariationGift: USER_ACTION_TYPES.ADD_VARIATION_GIFT,
  RemoveVariationGift: USER_ACTION_TYPES.REMOVE_VARIATION_GIFT,
  View: 'View',
  GiftCheckoutPopupShow: 'GiftCheckoutPopupShow',
  GiftCheckoutPopupClick: 'GiftCheckoutPopupClick',
  CartError: 'CartError',
  CheckoutNameInput: EVENT_NAME_FOR_CHECKOUT.CheckoutNameInput,
  DeliveryChange: 'DeliveryChange',
  PaymentChange: 'PaymentChange',
  CartCodeCreditPointApply: 'CartCodeCreditPointApply',
  CartMyCouponApply: 'CartMyCouponApply',
  CartMyCouponSelect: 'CartMyCouponSelect',
  CartCodeCreditPointEntranceClick: 'CartCodeCreditPointEntranceClick',
};

/**
 * Tracker event localStorage key
 *
 * The key stored in localStorage can be seen by developers. Use "sl" prefix
 */
export const TRACKER_LOCAL_STORAGE_KEYS = {
  purchaseEventTriggered: 'sl_purchase_event_triggered',
};

export const EXPERIMENT_START_FOR_AB_TESTING = 'ExperimentStart';

export const TRACKER_DEBOUNCE_DURATION = 1000;

/** Menu events */
export const MENU_TRACKER_TYPE = {
  HEADER_HAMBURGER_CLICK: 'HeaderHamburgerClick',
  MENU_CLICK: 'MenuClick',
  SEARCH_PRODUCT_ICON_CLICK: 'SearchProductIconClick',
};

/** Cart events */
// TODO: integrate all the event names for both v1 and v2.
// the event names for both v1 and v2.
export const CART_TRACKER_TYPE_FOR_V1_AND_V2 = {
  COUPON_CENTER_LINK_CLICK: 'CouponCenterLinkClick',
  DELIVERY_OPTION_CLICK: 'DeliveryOptionClick',
  PAYMENT_OPTION_CLICK: 'PaymentOptionClick',
  CART_CODE_CREDIT_POINT_ENTRANCE_CLICK: 'CartCodeCreditPointEntranceClick',
  CART_CODE_CREDIT_POINT_APPLY: 'CartCodeCreditPointApply',
  CART_MY_COUPON_APPLY: 'CartMyCouponApply',
  CART_MY_COUPON_SELECT: 'CartMyCouponSelect',
  PROMOTION_REMINDER_CLICK: 'PromotionReminderClick',
  PROMOTION_REMINDER_SHOW: 'PromotionReminderShow',
  CART_RECIPIENT_ADDRESS_TYPE: 'CartRecipientAddressType',
};

// TODO: collect all the event names for v1.
// the event names for v1 only.
export const CART_TRACKER_TYPE = {
  ADDON_PAGE_CLICK: 'AddonPageClick',
};
// TODO: collect all the event names for v2.
// the event names for v2 only.
export const CART_REVAMP_TRACKER_TYPE = {
  CartPageLoad: 'CartPageLoad',
  AddAddOnItem: 'AddAddOnItem',
  UpdateItem: 'UpdateItem',
  RemoveItem: 'RemoveItem',
  GoToCheckout: 'GoToCheckout',
  PaymentPromoOptionClick: 'PaymentPromoOptionClick',
  PaymentPromoOptionShow: 'PaymentPromoOptionShow',
  AddonAllListClick: 'AddonAllListClick',
  AddonAllListShow: 'AddonAllListShow',
  CartMemberLoginClick: 'CartMemberLoginClick',
  ProductImpression: 'ProductImpression',
  ViewRelatedProducts: 'ViewRelatedProducts',
  RecommendItem: 'RecommendItem',
  ProductClick: 'ProductClick',
  RecommendListClick: 'RecommendListClick',
  AddItem: 'AddItem',
  AddVariationGift: 'AddVariationGift',
  RemoveVariationGift: 'RemoveVariationGift',
};

/** Checkout events */
export const CHECKOUT_TRACKER_TYPE = {
  CHECKOUT_PAGE_LOAD: 'CheckoutPageLoad',
  ON_TRACK_CHECKOUT: 'OnTrackCheckout',
  CHECKOUT_CART_CLICK: 'CheckoutCartClick',
  CHECKOUT_MEMBER_LOG_IN_CLICK: 'CheckoutMemberLogInClick',
  CHECKOUT_THIRD_PARTY_SIGN_UP_CLICK: 'CheckoutThirdPartySignUpClick',
  CHECKOUT_NAME_INPUT: EVENT_NAME_FOR_CHECKOUT.CheckoutNameInput,
  CHECKOUT_PHONE_NUMBER_INPUT: 'CheckoutPhoneNumberInput',
  CHECKOUT_SAME_RECIPIENT_CLICK: 'CheckoutSameRecipientClick',
  CHECKOUT_RECIPIENT_NAME_INPUT: 'CheckoutRecipientNameInput',
  CHECKOUT_RECIPIENT_PHONE_INPUT: 'CheckoutRecipientPhoneInput',
  CHECKOUT_RECIPIENT_ADDRESS_TYPE: 'CheckoutRecipientAddressType',
  CHECKOUT_SUBMIT_BUTTON_CLICK: 'CheckoutSubmitButtonClick',
  STORE_PICKUP_REMEMBER: 'StorePickupRemember',
};

export const EVENT_FOR_MEMBER_CENTER = {
  MEMBER_REFERRAL_LINK_SHOW: 'MemberReferralLinkShow',
  MEMBER_REFERRAL_LINK_COPY: 'MemberReferralLinkCopy',
  MEMBER_REFERRAL_SIGN_UP_POPUP_SHOW: 'MemberReferralSignUpPopupShow',
};

/** Coupon Center events */
export const EVENT_NAME_FOR_COUPON_CENTER = {
  COUPON_CENTER_GO_TO_CART_SHOW: 'CouponCenterGoToCartShow',
  COUPON_CENTER_GO_TO_CART_CLICK: 'CouponCenterGoToCartClick',
  COUPON_USE_NOW_CLICK: 'CouponUseNowClick',
  COUPON_CENTER_POP_UP_IMPRESSION: 'CouponCenterPopUpImpression',
  COUPON_CENTER_POP_UP_CLICK: 'CouponCenterPopUpClick',
  COUPON_IMPRESSION: 'CouponImpression',
  COLLECT_COUPON_CLICK: 'CollectCouponClick',
  COUPON_CODE_REDEEM: 'CouponCodeRedeem',
  BUTTON_COLLECT_COUPON_CLICK: 'ButtonCollectCouponClick',
};
